import { Dispatch, useEffect, useState } from 'react';

import { isNull } from 'lodash';
import { useSelector } from 'react-redux';
import { DateConstant } from 'src/constants';

interface UseResendMfaCodeCountdownReturn {
  countdown: number;
  setCountdown: Dispatch<React.SetStateAction<number>>;
}

export const useResendMfaCodeCountdown = (): UseResendMfaCodeCountdownReturn => {
  const [countdown, setCountdown] = useState<number>(0);
  const oneMinuteAgo = new Date(Date.now() - DateConstant.ONE_MINUTE);

  const lastMfaCodeSentAt: Date | null = useSelector((state: any) => state.app.lastMfaCodeSentAt);

  const findCountdown = (last: Date) => {
    return Math.ceil((last.getTime() + DateConstant.ONE_MINUTE - Date.now()) / DateConstant.ONE_SECOND);
  };

  useEffect(() => {
    if (!isNull(lastMfaCodeSentAt) && lastMfaCodeSentAt >= oneMinuteAgo) {
      setCountdown(findCountdown(lastMfaCodeSentAt));
    }
  }, []);

  useEffect(() => {
    if (!isNull(lastMfaCodeSentAt)) {
      const oneMinuteAgo = new Date(Date.now() - DateConstant.ONE_MINUTE);

      if (lastMfaCodeSentAt >= oneMinuteAgo) {
        setCountdown(findCountdown(lastMfaCodeSentAt));

        const timer = setInterval(() => {
          setCountdown(prevCountdown => {
            if (prevCountdown <= 1) {
              clearInterval(timer);

              return 0;
            }

            return prevCountdown - 1;
          });
        }, 1000);

        return () => clearInterval(timer);
      }
    }
  }, [lastMfaCodeSentAt]);

  return {
    countdown,
    setCountdown,
  };
};
